<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: "primary",
  },
  showSpinner: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    required: false,
  },
});

const dynamicStyles: any = {};

switch (props.color) {
  case "secondary":
    dynamicStyles[`text-secondary-default`] = true;
    break;
  case "danger":
    dynamicStyles[`text-danger-default`] = true;
    break;
  case "warning":
    dynamicStyles[`text-warning-default`] = true;
    break;
  case "success":
    dynamicStyles[`text-success-default`] = true;
    break;
  case "google":
    dynamicStyles[`text-google-default`] = true;
    break;
  case "primary":
  default:
    dynamicStyles[`text-primary-default`] = true;
    break;
}
</script>

<template>
  <div
    v-tooltip="tooltip"
    class="text-body-2 relative cursor-pointer flex flex-row items-center justify-center select-none text-center border-b border-b-transparent hover:border-b-primary-default border-t border-t-transparent"
    :class="dynamicStyles"
    :style="{
      textIndent: '0px',
    }"
  >
    <ClientOnly>
      <slot />
    </ClientOnly>
  </div>
</template>

<style scoped>
.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 150ms ease-in;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
}
</style>
